import React, { useState } from 'react';
import style from './CareerAdd.module.css';
import axios from 'axios';
import { toast } from 'react-toastify';

const CareerAdd = () => {
  const [title, setTitle] = useState('');
  const [type, setType] = useState('');
  const [link, setLink] = useState('');

  const handleSubmit = async () => {
    const data = {
      title,
      description: link,
      type,
    };
    if (title && type && link) {
      await axios
        .post('/career', data, {
          headers: { 'Access-Control-Allow-Origin': '*' },
          withCredentials: true,
        })
        .then((res) => {
          toast.success(res.data);
          setTitle('');
          setLink('');
          setType('');
        })
        .catch((err) => {
          console.log(err);
          // toast.error(err.response.data.message);
        });
    } else toast.error('Fill all the fields');
  };
  return (
    <div className={style.Reset}>
      <p>Add Job Post</p>
      <div className={style.section}>
        <p>Title</p>
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          type='text'
          placeholder='Frontend engineer'
        />
        <p>Type</p>
        <input
          value={type}
          onChange={(e) => setType(e.target.value)}
          type='text'
          placeholder='OnSite / Remote'
        />
        <p>Link</p>
        <input
          value={link}
          onChange={(e) => setLink(e.target.value)}
          type='text'
          placeholder='www.doclink.com'
        />
      </div>
      <div onClick={handleSubmit} className={style.Button}>
        Add Job
      </div>
    </div>
  );
};

export default CareerAdd;
